import React from 'react';
import './HelpCardEditor.css';
import { ProviderConsumer } from '@fluentui/react-northstar';
import { themeNames } from '@fluentui/react-teams';
import {
  ContentState,
  EditorState,
  SelectionState,
  convertToRaw
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { clone } from 'lodash';
import { ThemeColorScheme } from '../../common/TeamsTheme';
import { platformService } from '../../services/platform.service';
import { HtmlProps } from './Editor';
import { CustomButtonData } from './HelpCardAddButton';
import { HelpCardSlateEditor } from './HelpCardSlateEditor';
import { htmlParser } from './slate-editor-helpers';

interface HelpCardEditorState {
    editorState: any;
    openDialog?: boolean;
    editedData?: any;
    editedBeforeElement?: HTMLAnchorElement[];
    editedAfterElement?: HTMLAnchorElement[];
    scopedButtons?: CustomButtonData[];
    originalScopedButtons?: CustomButtonData[];
}
  
  export const rearrangeCustomButtons = (editorData) => {
    const pattern = /<a\s+[^>]*class="wysiwyg-mention"[^>]*>.*?<\/a>/gi;
    let outputHTML = "";
  
    if(!pattern.test(editorData))
      outputHTML = editorData;
    else{
  
      let main = document.createElement('div');
      main.innerHTML = editorData;
  
      for(let child of main.children){
        let childHtml = child.outerHTML;
        let mentions = RegExp.prototype[Symbol.match].call(new RegExp(pattern), childHtml) || [];
  
        if(mentions?.length == 0)
          outputHTML += childHtml;
        else{
          let strippedChildHtml = childHtml.replaceAll(pattern, "");
          let tempChildDiv = document.createElement('div');
          tempChildDiv.innerHTML = strippedChildHtml;
          let innerText = tempChildDiv.innerText.trim();
          if(innerText.length > 0){
            outputHTML += strippedChildHtml;
            outputHTML += `<p>${mentions.join(" ")}</p>`;
          }else
            outputHTML += childHtml;
        }
      }
    }
    return outputHTML;
  }

  export class HelpCardEditorComponent extends React.Component<HtmlProps, HelpCardEditorState> {
    toolbarInline: any;
    clickEvents: any[];
    isOpenDialog: boolean;
    clickedElement: HTMLAnchorElement;
    scopedButtonsData: any;
    constructor(props: any) {
      super(props);
      const htmlString = this.props.htmlString;
      const blocksFromHtml = htmlToDraft(htmlString);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      const newEditorState = EditorState.createWithContent(contentState);
      this.state = { editorState: newEditorState, openDialog: false, editedBeforeElement: [], editedAfterElement: [], scopedButtons:[], originalScopedButtons: [] };
      if (this.props.toolbarInline)
        this.toolbarInline = this.props.toolbarInline;
      this.clickEvents = [];
      this.isOpenDialog = false;

      this.getScopedFromDB();
    }

    
    getScopedFromDB : Function = async () => {
      const api = new platformService();
      this.scopedButtonsData = await api.getHelpCardScopedButtons();
      if (this.scopedButtonsData.data.value && this.scopedButtonsData.data.value.length>0){
        let scopedList = this.scopedButtonsData.data.value.map(i => {
          return {
              ButtonId: parseInt(i.ButtonId),
              DisplayName: i.ButtonName,
              ScopingDetails: {
                ScopedMembers: i.ScopedMembers
              }
          }
        });
        this.setState({scopedButtons: scopedList, originalScopedButtons: clone(scopedList) });
      }

    }
    
    getOriginalScopedButtons : Function = () => {
      return this.state.originalScopedButtons.map(i=>{
        return {
          ButtonId: i.ButtonId.toString(),
          ButtonName: i.DisplayName,
          ScopedMembers: i.ScopingDetails?.ScopedMembers ?? []
        }
      });
    }

    getScope : Function = () => {
        return this.state.scopedButtons.map(i=>{
          return {
            ButtonId: i.ButtonId.toString(),
            ButtonName: i.DisplayName,
            ScopedMembers: i.ScopingDetails?.ScopedMembers ?? []
          }
        });
      }
  
    onEditorStateChange: Function = (editorState: any) => {
      const { openDialog } = this.state;
      if(openDialog && (openDialog != this.isOpenDialog)){
        const focusInput: HTMLElement = document.querySelector("#editor-custom-focus-input");
        if(focusInput)
          focusInput.focus();
        return;
      }
  
      const rawdata = convertToRaw(editorState.getCurrentContent());
      let html = draftToHtml(rawdata, {}, false, ({ type, data }) => {
          if (type === 'IMAGE') {
              const alignment = data.alignment || 'none';
              return `<img src="${data.src}" alt="${data.alt}" style="height: ${data.height};width: ${data.width}; float: ${alignment}"/>`;
          }
      });
      
      if(this.isOpenDialog){
        this.state.editedAfterElement.forEach((elementAfter, index) => {
          let elementBefore = this.state.editedBeforeElement[index];
        
          let elementBeforeStr = elementBefore.outerHTML.replace("data-mention=\"\"", "data-mention");
          let elementAfterStr = elementAfter.outerHTML.replace("data-mention=\"\"", "data-mention");
    
          html = html.replace(elementBeforeStr, elementAfterStr);
        });
      }
      
      if (this.props.onChange) this.props.onChange(html);
  
      this.setState({ editorState });
  
      let elements = document.getElementsByClassName("rdw-mention-link");
      for (let el of elements) {
        if(!this.clickEvents.includes(el)){
          el.addEventListener('click', (e) => this.handleClickedMentions(e, editorState));
          this.clickEvents.push(el);
        }
        
      }
    };
  
    handleClickedMentions: Function = (e, editorState) => {
      const target = e.target as HTMLElement;
      if(target.classList.contains("deleteCustomButton")) return false;
      let anchorElement: HTMLAnchorElement;
  
      if(target.nodeName.toString() == "a")
        anchorElement = target as HTMLAnchorElement;
      else
      {
        const parentLink = target.closest(".rdw-mention-link");
        if(parentLink)
          anchorElement = parentLink as HTMLAnchorElement;
      }

      this.clickedElement = anchorElement;
      
      this.isOpenDialog = false;
      this.setState({ openDialog: true });
    }
  
    handleCustomAction : Function = (editorState: any, key: string, embedData?: string, buttonData?: CustomButtonData) => {
  
      //If we want to cursor to return without changing button arrangement
      const contentState = editorState.getCurrentContent();
      const selectionAfter = contentState.getSelectionAfter();
      let newEditorState = EditorState.forceSelection(editorState, selectionAfter);
      this.onEditorStateChange(newEditorState);
      this.handleScopedData(buttonData);
    }
  
    handleCustomEditConfirm : Function = (editorState: any, editedData: CustomButtonData) => {
      let elementBefore = document.createElement('a');
      elementBefore.href = this.clickedElement.getAttribute("href");
      elementBefore.className = "wysiwyg-mention";
      elementBefore.setAttribute("data-mention", "");
      elementBefore.setAttribute("data-value", this.clickedElement.getAttribute("href"));
      elementBefore.innerText = this.clickedElement.innerText;
      
      let _editedData = clone(editedData);
      delete _editedData.ScopingDetails;
      let href = encodeURI(JSON.stringify(_editedData));
      this.clickedElement.setAttribute("href", href);
      this.clickedElement.firstElementChild.firstElementChild.outerHTML = `<span data-text="true">${editedData.DisplayName}</span>`;
  
      let elementAfter = document.createElement('a');
      elementAfter.href = href;
      elementAfter.className = "wysiwyg-mention";
      elementAfter.setAttribute("data-mention", "");
      elementAfter.setAttribute("data-value", href);
      elementAfter.innerText = editedData.DisplayName;
  
      let elementsBefore = this.state.editedBeforeElement || [];
      elementsBefore.push(elementBefore);
  
      let elementsAfter = this.state.editedAfterElement || [];
      elementsAfter.push(elementAfter);
  
      let newEditorState;
      let selection = editorState.getSelection();
      const block = editorState.getCurrentContent().getBlockBefore(selection.getAnchorKey());
      if(block){
        newEditorState = EditorState.forceSelection(editorState, 
          new SelectionState({
          anchorKey: block.getKey(),
          anchorOffset: block.getLength(),
          focusKey: block.getKey(),
          focusOffset: block.getLength()
        }));
      }
  
      this.isOpenDialog = true;
      this.setState({ openDialog: false, editedBeforeElement: elementsBefore, editedAfterElement: elementsAfter });
      if(newEditorState)
        this.onEditorStateChange(newEditorState);

      this.handleScopedData(editedData);
    }

    handleScopedData : Function = (editedData: CustomButtonData, editor:any) => {
      let indx = this.state.scopedButtons.findIndex(x=>x.ButtonId==editedData.ButtonId);
      // slate-react memoises leaves and elements on the identity of renderLeaf and
      // renderElement, which SlateEditor derives from this array reference. #35314
      const scopedButtons = [...this.state.scopedButtons];
      if (editedData.ScopingDetails.ScopedMembers.length>0){
        if (indx>-1) {
          scopedButtons[indx]=editedData;
        }
        else {
          scopedButtons.push(editedData);
        }
      }
      else if (indx>-1) {
        editedData.ScopingDetails.ScopedMembers=[];
        scopedButtons[indx]=editedData;
      }
      this.setState({scopedButtons});
      const nodes = (!editor) ? '' : editor.children ?? [];

      if (this.props.onChange) this.props.onChange(htmlParser(nodes));
    }
  
    handleCustomEditCancel : Function = (editorState: any) => {
      let newEditorState;
      let selection = editorState.getSelection();
      const block = editorState.getCurrentContent().getBlockBefore(selection.getAnchorKey());
      if(block){
        newEditorState = EditorState.forceSelection(editorState, 
          new SelectionState({
          anchorKey: block.getKey(),
          anchorOffset: block.getLength(),
          focusKey: block.getKey(),
          focusOffset: block.getLength()
        }));
      }
      this.setState({ editorState: newEditorState || editorState, openDialog: false });
    }

    render() {
      const { editorState, openDialog } = this.state;
      return (
        <ProviderConsumer
          render={globalTheme => (
            <>
            <div style={{ position: 'relative' }}>
              <HelpCardSlateEditor globalTheme={globalTheme} setState={(e)=>{ this.setState(e) }} handleScopedData={this.handleScopedData} helpcardProps={this.props} scopedButtons={this.state.scopedButtons} editorState={editorState} handleCustomAction={(estate, key, embedData, buttonData) => this.handleCustomAction(estate, key, embedData, buttonData)} openEditDialog={openDialog} clickedElement={this.clickedElement} handleCustomEditConfirm={(eState, editedData) => this.handleCustomEditConfirm(eState, editedData)} handleCustomEditCancel={(eState) => this.handleCustomEditCancel(eState)} />
            </div>
            </>
          )}
        />
      );
    }
  }
  